import api from "../../../../../api/api"


const importTallyVouchers = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("import/tally/vouchers/vouchers",payload
        ).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const voucherImportServices = {
    importTallyVouchers,
}

export default voucherImportServices;